export enum OrderAction {
    FORWARD_TO_IN_REVIEW,
    FORWARD_TO_WAREHOUSE_OPERATION,
    FORWARD_APPROVES_TO_WAREHOUSE_OPERATION,
    CANCEL,
    COMPLETE,
    APPROVE_ALL_ITEMS,
}
